<template>
  <div id="CheckEligibilityStage">
    <ffs-welcome></ffs-welcome>
    <el-container>
      <el-aside width="150px" max-width="">
        <img src="/img/step_images/icon-step-1.png" width="80px" height="58px" alt="Picture of a circle with 'Step 1' in the center.">
        <div>Please answer ALL of the following questions.  They help us learn your story.</div>
      </el-aside>
      <el-container>
        <el-main>
          <ffs-profile></ffs-profile>
        </el-main>
      </el-container>
    </el-container>
    <el-container id="EligibilityCharges">
      <el-aside width="150px">
        <img src="/img/step_images/icon-step-2.png" width="80px" height="58px" alt="Picture of a circle with 'Step 2' in the center.">
        <div>Click "Yes" if you've pled guilty or no-contest to any of the following:</div>
      </el-aside>
      <el-container>
        <el-main>
          <ffs-charges></ffs-charges>
        </el-main>
      </el-container>
    </el-container>
    <el-container id="EligibilityResults">
      <el-aside width="150px">
        <img src="/img/step_images/icon-step-3.png" width="80px" height="58px" alt="Picture of a circle with 'Step 3' in the center.">
        <div>Ok, so here is what we think you can do.</div>
      </el-aside>
      <el-container>
        <el-main>
          <ffs-results v-bind:profileData="Profile" v-bind:chargeData="Charges"></ffs-results>
        </el-main>
      </el-container>
    </el-container>
    <template v-if="Result.RequestsExpungementHelp || Result.RequestsConsumerHelp">
      <el-container id="EligibilityHelp">
        <el-aside width="150px">
          <img src="/img/step_images/icon-step-4.png" width="80px" height="58px" alt="Picture of a circle with 'Step 4' in the center.">
          <div>Let's see if we can find someone that can help.</div>
        </el-aside>
        <el-container>
          <el-main>
            <ffs-help v-bind:resultData="Result"></ffs-help>
          </el-main>
        </el-container>
      </el-container>
    </template>
  </div>
</template>

<script>
import EventBus from '../../EligibilityEventBus.js'

import { Main, Container, Aside } from 'element-ui' // eslint-disable-line no-unused-vars

const WelcomeDialogView = () => import(/* webpackChunkName: "WelcomeDialog" */ '@/components/views/WelcomeDialog.vue')
const ProfileView = () => import(/* webpackChunkName: "ProfileView" */ '@/components/views/ProfileView.vue')
const ChargesView = () => import(/* webpackChunkName: "ChargesView" */ '@/components/views/ChargesView.vue')
const ResultsView = () => import(/* webpackChunkName: "ResultsView" */ '@/components/views/ResultsView.vue')
const FindHelpView = () => import(/* webpackChunkName: "FindHelpView" */ '@/components/views/FindHelpView.vue')

export default {
  name: 'home',
  data: function () {
    return {
      Profile: {
        complete: false,
        StepState: 'analysis'
      },
      Charges: {
        complete: false,
        StepState: ''
      },
      Result: {
        isExpungementEligible: false,
        isJuvenile: false,
        isJuvenileEarlyEligible: false,
        completedJuvenileDiversion: false,
        RequestsExpungementHelp: false,
        RequestsConsumerHelp: false,
        ExpungementNotes: '',
        ConsumerNotes: '',
        StepState: '',
        hasConsumerIssue: false
      }
    }
  },

  components: {
    'ffs-profile': ProfileView,
    'ffs-charges': ChargesView,
    'ffs-results': ResultsView,
    'ffs-help': FindHelpView,
    'el-main': Main,
    'el-container': Container,
    'el-aside': Aside,
    'ffs-welcome': WelcomeDialogView
  },

  methods: {
    setProfileComplete (payload) {
      this.Profile = Object.assign(this.Profile, payload)

      this.Profile.StepState = 'success'
      this.Profile.complete = true
      this.Charges.StepState = 'analysis'
      this.$root.$router.push({ name: 'EligibilityCharges' })
    },

    setChargesComplete (payload) {
      this.Charges = Object.assign(this.Charges, payload)

      this.Charges.StepState = 'success'
      this.Charges.complete = true
      this.Result.StepState = 'success'
      this.$root.$router.push({ name: 'EligibilityResults' })
    },

    getChargesState () {
      return this.Charges.complete
    },

    handleCompletedEligibility (payload) {
      this.Result.isExpungementEligible = payload.isEligible
      this.Result.isJuvenile = payload.isJuvenile
      this.Result.isJuvenileEarlyEligible = payload.isEarlyEligible
      this.Result.completedJuvenileDiversion = payload.completedDiversion
      this.Result.ExpungementNotes = payload.notes
    },

    handleCompletedConsumerEligibility (payload) {
      this.Result.hasConsumerIssue = payload.result
      this.Result.ConsumerNotes = payload.notes
    },

    handleRequestingHelp (payload) {
      this.Result.RequestsExpungementHelp = payload.isRequestingExpungementHelp
      this.Result.RequestsConsumerHelp = payload.isRequestingConsumerHelp

      this.$root.$router.push({ name: 'EligibilityHelp' })
    },

    handleRequestingSelfHelp () {
      this.$root.$router.push({ name: 'SelfHelp' })
    }
  },

  created: function () {
    EventBus.$on('ProfileComplete', this.setProfileComplete)
    EventBus.$on('ChargesComplete', this.setChargesComplete)
    EventBus.$on('completedEligibility', this.handleCompletedEligibility)
    EventBus.$on('completedConsumerEligibility', this.handleCompletedConsumerEligibility)
    EventBus.$on('requestHelp', this.handleRequestingHelp)
    EventBus.$on('visitSelfHelp', this.handleRequestingSelfHelp)
  }
}
</script>

<style scoped>
.el-aside {
  text-align: left;
  vertical-align: sub;
}

.el-aside img {
  margin-top: 25px;
  margin-bottom: 25px;
}

.QuestionInstructions {
  text-align: left;
  margin-bottom: 20px;
  font-weight: bold;
  font-size: 1.5em;
}

div > .el-container {
  padding-left: 40px;
  padding-right: 40px;
}

div > .el-container:nth-child(2) {
  background-color: #fafafa;
}

div > .el-container:nth-child(4) {
  background-color: #fafafa;
}

div > .el-container:last-of-type {
  margin-bottom: 0px;
}

div#CheckEligibilityStage {
  margin-top: 20px;
  margin-bottom: 20px;
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
}

div#CheckEligibilityStage >>> #ResultsStage .el-card {
  text-align: center;
}

.CheckEligibilityStage >>> #ResultsStage .el-card p {
  text-align: left;
}
</style>
